<template>
  <div class="flex width-100 flex-column">
    <div class="width-100">
      <div class="flex width-100 justify-space-between">
        <h2>Dashboard Translate</h2>
        <el-button type="primary" size="default" @click="saveTranslation">Save Translation</el-button>
      </div>
      <Spacer />
      <el-alert type="warning">
        <template slot="title">
            <b>PLEASE READ BEFORE DOING ANY ACTION</b><br>
            Follow these steps to translate the Dashboard:
            <ol>
              <li>Choose the Language you want to translate to from the dropdown below</li>
              <li>Fill the empty fields with the corresponding values</li>
              <li>Press "Save Translation" to save your work</li>
            </ol>
        </template>
      </el-alert>
      <Spacer />
      <GridContainer
        class="align-left"
      >
        <el-row :gutter="20">
          <el-col
            :span="12"
            :offset="0"
          >
            <el-select
              v-model="selectValue"
              placeholder="Select Language To Edit"
              @change="fetchLang"
            >
              <el-option
                v-for="item in select"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
            <Spacer />
            <Spacer />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="12"
            :offset="0"
          >
            <h4>ORIGINAL VALUE</h4>
            <el-row v-for="(field, key) in originalFields" :key="key">
              <el-col
                :span="24"
                :offset="0"
                style="margin-top: 10px"
              >
                <div v-if="(typeof field) == 'string'" class="value-holder">
                  <div class="key">{{ key }}</div>
                  <div class="input-holder">
                    <el-input :value="field" disabled size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                  </div>
                </div>
                <div v-else>
                  <div class="section-title">{{ key }}</div>
                  <div v-for="(fl, k) in field" :key="k">
                    <div v-if="(typeof fl) == 'string'" class="value-holder lvl1">
                      <div class="key">{{ k }}</div>
                      <div class="input-holder">
                        <el-input :value="fl" disabled size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                      </div>
                    </div>
                    <div v-else class="lvl1">
                      <div class="section-title">{{ k }}</div>
                      <div v-for="(fi, kk) in fl" :key="kk">
                        <div v-if="(typeof fi) == 'string'" class="value-holder lvl2">
                          <div class="key">{{ kk }}</div>
                          <div class="input-holder">
                            <el-input :value="fi" disabled size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                          </div>
                        </div>
                        <div v-else class="lvl2">
                          <div class="section-title">{{ kk }}</div>
                          <div v-for="(fie, kkk) in fi" :key="kkk">
                            <div v-if="(typeof fie) == 'string'" class="value-holder lvl3">
                              <div class="key">{{ kkk }}</div>
                              <div class="input-holder">
                                <el-input :value="fie" disabled size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                              </div>
                            </div>
                            <div v-else class="lvl3">
                              <div class="section-title">{{ kkk }}</div>
                              <div v-for="(fd, kkkk) in fie" :key="kkkk">
                                <div v-if="(typeof fd) == 'string'" class="value-holder lvl4">
                                  <div class="key">{{ kkkk }}</div>
                                  <div class="input-holder">
                                    <el-input :value="fd" disabled size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col
            :span="12"
            :offset="0"
          >
            <h4>NEW VALUE</h4>
            <el-row v-for="(field, key) in fields" :key="key">
              <el-col
                :span="24"
                :offset="0"
                style="margin-top: 10px"
              >
                <div v-if="(typeof field) == 'string'" class="value-holder">
                  <div class="key">{{ key }}</div>
                  <div class="input-holder">
                    <el-input v-model="fields[key]" size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                  </div>
                </div>
                <div v-else>
                  <div class="section-title">{{ key }}</div>
                  <div v-for="(fl, k) in field" :key="k">
                    <div v-if="(typeof fl) == 'string'" class="value-holder lvl1">
                      <div class="key">{{ k }}</div>
                      <div class="input-holder">
                        <el-input v-model="fields[key][k]" size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                      </div>
                    </div>
                    <div v-else class="lvl1">
                      <div class="section-title">{{ k }}</div>
                      <div v-for="(fi, kk) in fl" :key="kk">
                        <div v-if="(typeof fi) == 'string'" class="value-holder lvl2">
                          <div class="key">{{ kk }}</div>
                          <div class="input-holder">
                            <el-input v-model="fields[key][k][kk]" size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                          </div>
                        </div>
                        <div v-else class="lvl2">
                          <div class="section-title">{{ kk }}</div>
                          <div v-for="(fie, kkk) in fi" :key="kkk">
                            <div v-if="(typeof fie) == 'string'" class="value-holder lvl3">
                              <div class="key">{{ kkk }}</div>
                              <div class="input-holder">
                                <el-input v-model="fields[key][k][kk][kkk]" size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                              </div>
                            </div>
                            <div v-else class="lvl3">
                              <div class="section-title">{{ kkk }}</div>
                              <div v-for="(fd, kkkk) in fie" :key="kkkk">
                                <div v-if="(typeof fd) == 'string'" class="value-holder lvl4">
                                  <div class="key">{{ kkkk }}</div>
                                  <div class="input-holder">
                                    <el-input v-model="fields[key][k][kk][kkk][kkkk]" size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 30 }"></el-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        
      </GridContainer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DashboardTranslate',
  data() {
    return {
      fields: {},
      newFields: {},
      langFields: {},
      originalFields: {},
      select: [
        { code: 'EN', name: 'English' },
        { code: 'KO', name: 'Korean' },
        { code: 'TR', name: 'Turkish' }
      ],
      selectValue: null,
      show: false
    }
  },
  computed: {
    translations() {
      return require('@/config/translations/dashboard.js').default
    }
  },
  created() {
    this.$store.dispatch('cms/getLanguageFromBack', 'EN').then(result => {
      // this.fields = this.formatResults(result.translationKeys)
      this.originalFields = JSON.parse(result.translationSequence)
    })
    // this.$store.dispatch('cms/getLanguageCodesFromApi').then(result => {
    //   this.select = result
    // })
  },
  methods: {
    formatResults(results) {
      let finalObject = {}

      const obj = Object.entries(results)
      console.log(obj)

      results.forEach(element => {
        if (element.value == null && element.parentId == null) {
          let firstLevelObject = {}
          let firstLevelItems = results.filter(obj => {
            return obj.parentId === element.id
          })
          firstLevelItems.forEach(elem => {
            if (elem.value == null) {
              let secondLevelObject = {}
              let secondLevelItems = results.filter(ob => {
                return ob.parentId === elem.id
              })

              secondLevelItems.forEach(el => {
                if (el.value == null) {
                  let thirdLevelObject = {}
                  let thirdLevelItems = results.filter(o => {
                    return o.parentId === el.id
                  })

                  thirdLevelItems.forEach(elm => {
                    if (elm.value == null) {
                      let fourthLevelObject = {}
                      let fourthLevelItems = results.filter(o => {
                        return o.parentId === elm.id
                      })
                      fourthLevelItems.forEach(elmn => {
                        if (elmn.value == null) {
                          // let fifthLevelObject = {}
                          // let fifthLevelItems = results.filter(objc => {
                          //   return objc.parentId === elmn.id
                          // })
                        }
                        else {
                          // Add Single Value to 4th lvl
                          fourthLevelObject[elmn.key] = elmn
                        }
                      })
                      // Add 4th lvl obj to 3rd lvl
                      thirdLevelObject[elm.key] = fourthLevelObject
                    }
                    else {
                      // Add single value to 3rd lvl
                      thirdLevelObject[elm.key] = elm
                    }
                  })
                  // Add 3rd lvl obj to 2nd lvl
                  secondLevelObject[el.key] = thirdLevelObject
                }
                else {
                  // Add single value to 2nd lvl
                  secondLevelObject[el.key] = el
                }
              })
              // Add 2nd lvl obj to 1st lvl
              firstLevelObject[elem.key] = secondLevelObject
            }
            else {
              // Add single value to 1st lvl
              firstLevelObject[elem.key] = elem
            }
          })
          // Add obj to initial lvl
          finalObject[element.key] = firstLevelObject
        }
        else {
          if (element != null && element.parentId == null) { finalObject[element.key] = element }
        }
      })

      return finalObject
    },
    mergeLangs() {
      // let finalObj = {}
      for (const key in this.fields) {
        const smth = this.langFields.filter(lf => this.fields[key].fullKey === lf.fullKey)
        if (smth[0] !== undefined) {
          this.fields[key].value = smth[0].value
        }
        else {
          if (this.fields[key].value !== undefined) {
            this.fields[key].value = null
          }
        }
        for (const k in this.fields[key]) {
          if (this.fields[key][k] !== null && typeof this.fields[key][k] === 'object') {
            const st = this.langFields.filter(lf => this.fields[key][k].fullKey === lf.fullKey)
            if (st[0] !== undefined) {
              this.fields[key][k].value = st[0].value
            }
            else {
              if (this.fields[key][k].value !== undefined) {
                this.fields[key][k].value = null
              }
            }
            for (const kk in this.fields[key][k]) {
              if (this.fields[key][k][kk] !== null && typeof this.fields[key][k][kk] === 'object') {
                const stt = this.langFields.filter(lf => this.fields[key][k][kk].fullKey === lf.fullKey)
                if (stt[0] !== undefined) {
                  this.fields[key][k][kk].value = stt[0].value
                }
                else {
                  if (this.fields[key][k][kk].value !== undefined) {
                    this.fields[key][k][kk].value = null
                  }
                }
              }
            }
          }
        }
      }
      this.newFields = JSON.parse(JSON.stringify(this.fields))
      this.show = true
    },
    fetchLang(value) {
      this.$store.dispatch('cms/getLanguageFromBack', value).then(result => {
        // this.langFields = result.translationKeys
        this.fields = JSON.parse(result.translationSequence)
        // this.mergeLangs()
      })
      // this.$store.dispatch('cms/getLanguageDetailedFromApi', value).then(result => {
      //   // this.langFields = result.translationKeys
      //   this.fields = this.formatResults(result.translationKeys)
      //   // this.mergeLangs()
      // })
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.readFile(files[0])
    },
    readFile(file) {
      let reader = new FileReader()
      reader.onload = e => {
        let json = JSON.parse(e.target.result)
        console.log(json)
        let obj = this.addMissingFields(json)
        this.newFields = obj
      }
      reader.readAsText(file)
    },
    addMissingFields(obj) {
      for (const key in this.fields) {
        // if (obj[key] === undefined) {
        if (typeof this.fields[key] === 'string') {
          obj[key] = obj[key] === null || obj[key] === undefined || typeof obj[key] !== 'string' ? this.fields[key] : obj[key]
        }
        else {
          obj[key] = obj[key] === null || obj[key] === undefined || typeof obj[key] !== 'object' ? this.fields[key] : obj[key]
          for (const k in this.fields[key]) {
            // if (obj[key][k] === undefined) {
            if (typeof this.fields[key][k] === 'string') {
              obj[key][k] = obj[key][k] === null || obj[key][k] === undefined || typeof obj[key][k] !== 'string' ? this.fields[key][k] : obj[key][k]
            }
            else {
              obj[key][k] = obj[key][k] === null || obj[key][k] === undefined || typeof obj[key][k] !== 'object' ? this.fields[key][k] : obj[key][k]

              for (const kz in this.fields[key][k]) {
                // if (obj[key][k][kz] === undefined) {
                if (typeof this.fields[key][k][kz] === 'string') {
                  obj[key][k][kz] = obj[key][k][kz] === null || obj[key][k][kz] === undefined || typeof obj[key][k][kz] !== 'string' ? this.fields[key][k][kz] : obj[key][k][kz]
                }
                else {
                  obj[key][k][kz] = obj[key][k][kz] === null || obj[key][k][kz] === undefined || typeof obj[key][k][kz] !== 'object' ? this.fields[key][k][kz] : obj[key][k][kz]
                  for (const kzx in this.fields[key][k][kz]) {
                    // if (obj[key][k][kz][kzx] === undefined) {
                    if (typeof this.fields[key][k][kz][kzx] === 'string') {
                      obj[key][k][kz][kzx] = obj[key][k][kz][kzx] === null || obj[key][k][kz][kzx] === undefined || typeof obj[key][k][kz][kzx] !== 'string' ? this.fields[key][k][kz][kzx] : obj[key][k][kz][kzx]
                    }
                    else {
                      obj[key][k][kz][kzx] = obj[key][k][kz][kzx] === null || obj[key][k][kz][kzx] === undefined || typeof obj[key][k][kz][kzx] !== 'object' ? this.fields[key][k][kz][kzx] : obj[key][k][kz][kzx]
                      for (const kzxy in this.fields[key][k][kz][kzx]) {
                        // if (obj[key][k][kz][kzx][kzxy] === undefined) {
                        if (typeof this.fields[key][k][kz][kzx][kzxy] === 'string') {
                          obj[key][k][kz][kzx][kzxy] = obj[key][k][kz][kzx][kzxy] === null || obj[key][k][kz][kzx][kzxy] === undefined || typeof obj[key][k][kz][kzx][kzxy] !== 'string' ? this.fields[key][k][kz][kzx][kzxy] : obj[key][k][kz][kzx][kzxy]
                        }
                        else {
                          obj[key][k][kz][kzx][kzxy] = obj[key][k][kz][kzx][kzxy] === null || obj[key][k][kz][kzx][kzxy] === undefined || typeof obj[key][k][kz][kzx][kzxy] !== 'object' ? this.fields[key][k][kz][kzx][kzxy] : obj[key][k][kz][kzx][kzxy]
                          // for (const kzxy in this.fields[key][k][kz]) {

                          // }
                        }
                        // }
                      }
                    }
                  }
                }
                // }
              }
            }
            // }
          }
        }
        // }
      }
      return obj
    },
    exportData() {
      const data = JSON.stringify(this.newFields)
      const blob = new Blob([data], { type: 'text/plain' })
      const e = document.createEvent('MouseEvents')
      const a = document.createElement('a')
      a.download = 'test.json'
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    saveTranslation() {
      const obj = {
        translationSequence: JSON.stringify(this.fields),
        lang: this.selectValue
      }

      this.$store.dispatch('cms/saveTranslation', obj).then(result => {
        if (result === 200) {
          this.successNotification('Translation has been saved!')
        }
      })
      
    }
  }
}
</script>

<style lang="scss">
.value-holder {
  display: flex;
  flex: 0 0 100%;
  align-items: center;
  margin: 5px 0;
  .key {
    flex: 0 0 20%;
    font-size: 12px;
  }
  .input-holder {
    flex: 0 0 70%;
  }
}
.section-title {
  font-weight: bold;
}
.lvl1{
  text-indent: 15px;
}
.lvl2{
  text-indent: 25px;
}
.lvl3{
  text-indent: 30px;
}
.lvl4{
  text-indent: 40px;
}
.lvl5{
  text-indent: 50px;
}
</style>
